export default "/images/a300bd4e14c0556c8ca829a907cb9e83.avif";